<script>
export default {
  data () {
    return {
      rs_timer: null,
      headerHeight: 0,
      footerHeight: 0,
      windowWidth: 0,
      windowHeight: 0,
      scrollbarSize: 0
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth <= 1099.9
    }
  },
  created () {
    const handler = () => {
      this.rs_timer && clearTimeout(this.rs_timer)
      if (window.innerHeight > window.screen.height) {
        this.rs_timer = setTimeout(() => {
          this.rs_timer = null
          window.dispatchEvent(new Event('resize'))
        }, 100)
      } else {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
        this.headerHeight = this.isMobile ? 70 : 100
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
    window.dispatchEvent(new Event('resize'))
  },
  mounted () {
    const scrollBox = document.getElementById('scroll-box')
    this.scrollbarSize = scrollBox.offsetWidth - scrollBox.clientWidth
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/responsitive.vue